import { render, staticRenderFns } from "./InvoicesControl.vue?vue&type=template&id=3b5bcd99&"
import script from "./InvoicesControl.vue?vue&type=script&lang=js&"
export * from "./InvoicesControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports